<form fxLayout="column" name="itinerary-settings-assignment-form" *ngIf="users && assignmentProposals">
  <div class="proposed-assignees-card-wrapper">
    <mat-card>
      <h4 style="margin-bottom: 8px;">Potenziali Travel Advisors<small> ({{
          itinerary.proposedAssignees.length
          }})</small></h4>
      <div *ngFor="let proposedAssigneeRef of itinerary.proposedAssignees" fxLayout="row" fxLayoutAlign="start center">
        <ng-container *ngIf="getUserByRef(proposedAssigneeRef); let proposedAssignee">
          <ng-container *ngIf="
              getAssignmentProposalByUserRef(proposedAssigneeRef);
              let assignmentProposal;
              else: emptyAssignmentProposalRow
            ">
            <mat-icon mat-list-icon *ngIf="assignmentProposal.accepted" class="green"
              matTooltip="Proposta d'incarico accettata!">check_circle_outline</mat-icon>
            <mat-icon mat-list-icon *ngIf="assignmentProposal.rejected" class="red"
              matTooltip="Proposta d'incarico rifiutata">highlight_off</mat-icon>
            <mat-icon mat-list-icon *ngIf="
                !assignmentProposal.accepted && !assignmentProposal.rejected
              " matTooltip="Proposta d'incarico in attesa di risposta">help_outline</mat-icon>
            <span> &nbsp;&nbsp;&nbsp;</span>
            <p fxFlex>
              {{ proposedAssignee.displayName
              }}<ng-container *ngIf="proposedAssignee.displayName"><small> &mdash; </small></ng-container><small>{{
                proposedAssignee.email }}</small>
            </p>
            <p *ngIf="assignmentProposal.proposalDate">
              <small>proposed on
                <b>{{
                  assignmentProposal.proposalDate.toDate() | date: "short"
                  }}</b></small>
            </p>
            <p *ngIf="assignmentProposal.answerDate">
              <span>&nbsp;&nbsp;&nbsp;</span>
              <small>answered on
                <b>{{
                  assignmentProposal.answerDate.toDate() | date: "short"
                  }}</b></small>
            </p>
            <p>
              <span>&nbsp;&nbsp;&nbsp;</span>

              <small>compenso
                <b [ngStyle]="{
                    'text-decoration': assignmentProposal.test
                      ? 'line-through'
                      : 'none'
                  }">{{ assignmentProposal.fee | number: "1.2-2" }} €</b></small>
            </p>
          </ng-container>
          <ng-template #emptyAssignmentProposalRow>
            <mat-icon mat-list-icon matTooltip="Proposta d'incarico non ancora inviata">add_circle_outline</mat-icon>
            <span> &nbsp;&nbsp;&nbsp;</span>
            <p fxFlex>
              {{ proposedAssignee.displayName
              }}<ng-container *ngIf="proposedAssignee.displayName"><small> &mdash; </small></ng-container><small>{{
                proposedAssignee.email }}</small>
            </p>
          </ng-template>
        </ng-container>
      </div>
      <div>
        <button mat-raised-button color="primary" *ngIf="
        !itinerary.assignee &&
        !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)" (click)=" addAssignmentProposals()">
          <mat-icon>add</mat-icon> Aggiungi
        </button>
      </div>
    </mat-card>
    <div>&nbsp;&nbsp;&nbsp;</div>
  </div>
  <mat-form-field appearance="outline" *ngIf="users">
    <mat-label>Travel Advisor incaricato</mat-label>
    <mat-select [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
      [(ngModel)]="itinerary.assignee" name="assignee" [compareWith]="refCompareFn">
      <mat-option [value]="null"> </mat-option>
      <ng-container *ngFor="let user of sort(users)">
        <mat-option *ngIf="
            getAssignmentProposalByUserRef(ref('users/' + user.id))?.accepted
          " [value]="ref('users/' + user.id)">
          {{ user.displayName
          }}<ng-container *ngIf="user.displayName"><small> &mdash; </small></ng-container><small>{{ user.email
            }}</small>
        </mat-option>
      </ng-container>
      <!-- 11may2021 backward compat -->
      <mat-option *ngIf="
          itinerary.assignee &&
          !getAssignmentProposalByUserRef(itinerary.assignee)
        " [value]="itinerary.assignee">
        {{ itinerary.assigneeData.displayName
        }}<ng-container *ngIf="itinerary.assigneeData.displayName"><small> &mdash; </small></ng-container>
        <small>{{
          itinerary.assigneeData.email }}</small>
      </mat-option>
      <!-- 11may2021 backward compat -->
    </mat-select>
  </mat-form-field>
</form>